export default [
  {
    path: '/dashboard',
    component: () => import('@/pages/insurer/Dashboard.vue'),
    name: 'insurer.dashboard',
    meta: {
      requiresAuth: true,
      title: 'Dashboard',
    },
  },
  {
    path: '/inspection',
    component: () => import('@/pages/insurer/inspection/Inspection.vue'),
    name: 'insurer.inspection',
    meta: {
      breadCrumb: 'Pre-Policy Inspections',
      requiresAuth: true,
      title: 'Pre-Policy Inspection',
    },
  },
  {
    path: '/inspection/start',
    component: () => import('@/pages/insurer/inspection/InspectionForm.vue'),
    name: 'insurer.inspection.start',
    meta: {
      breadCrumb: 'Vehicle Inspection',
      requiresAuth: true,
    },
  },
  {
    path: '/inspection/:id',
    component: () => import('@/pages/insurer/inspection/InspectionDetail.vue'),
    props: true,
    name: 'insurer.inspection.detail',
    meta: {
      breadCrumb: 'Pre-Policy Inspection',
      requiresAuth: true,
      title: 'Pre-Policy Inspection Detail',
    },
  },
  {
    path: '/orders',
    component: () => import('@/pages/insurer/policy/Policies.vue'),
    name: 'insurer.orders',
    meta: {
      breadCrumb: 'Policies',
      requiresAuth: true,
      title: 'Orders',
    },
  },
  {
    path: '/orders/:id',
    component: () => import('@/pages/insurer/policy/policy-details.vue'),
    name: 'insurer.orders.detail',
    meta: {
      breadCrumb: 'Policy',
      requiresAuth: true,
      title: 'Order detail',
    },
  },
  {
    path: '/collections',
    component: () => import('@/pages/insurer/claims/Collections.vue'),
    name: 'insurer.claims',
    meta: {
      breadCrumb: 'Claims',
      requiresAuth: true,
      title: 'Claims',
    },
  },
  {
    path: '/collections/:id',
    component: () => import('@/pages/insurer/claims/CollectionDetails.vue'),
    name: 'insurer.claims.detail',
    props: true,
    meta: {
      breadCrumb: 'Claim',
      requiresAuth: true,
      title: 'Claims Detail',
    },
  },
  {
    path: 'settings',
    redirect: '/settings/profile',
    component: () => import('@/pages/settings/Index.vue'),
    name: 'insurer.settings',
    children: [
      {
        path: 'profile',
        component: () => import('@/pages/settings/Profile.vue'),
        name: 'insurer.settings.profile',
        meta: {
          requiresAuth: true,
          title: 'Profile - Settings',
        },
      },
      // {
      //   path: 'password',
      //   component: () => import('@/pages/settings/Password.vue'),
      //   name: 'insurer.settings.password',
      //   meta: {
      //     requiresAuth: true,
      //     title: 'Password - Settings',
      //   },
      // },
      {
        path: 'developer',
        component: () => import('@/pages/settings/Developer.vue'),
        name: 'insurer.settings.developer',
        meta: {
          requiresAuth: true,
          title: 'Developer - Settings',
        },
      },
      {
        path: 'notification',
        component: () => import('@/pages/settings/notification/index.vue'),
        name: 'insurer.settings.notification',
        meta: {
          requiresAuth: true,
          title: 'Notification - Settings',
        },
      },
      {
        path: 'api-usage-logs',
        component: () => import('@/pages/settings/audits/api-usage-logs.vue'),
        name: 'insurer.settings.api-usage-logs',
        meta: {
          requiresAuth: true,
          title: 'API Usage Logs - Settings',
        },
      },
      {
        path: 'audit-logs',
        component: () => import('@/pages/settings/audits/logs.vue'),
        name: 'insurer.settings.audit-logs',
        meta: {
          requiresAuth: true,
          title: 'Audit Logs - Settings',
        },
      },
    ],
  },
  {
    path: '/fleets',
    component: () => import('@/pages/insurer/fleet/index.vue'),
    name: 'insurer.fleet',
    meta: {
      breadCrumb: 'Fleet Inspection',
      requiresAuth: true,
      title: 'Fleet Inspection',
    },
  },
  {
    path: '/fleets/:id',
    component: () => import('@/pages/insurer/fleet/details.vue'),
    props: true,
    name: 'insurer.fleet.details',
    meta: {
      breadCrumb: 'Fleet Details',
      requiresAuth: true,
      title: 'Fleet Inspection Detail',
    },
  },
  {
    path: '/orders/fleets/:id/policies',
    component: () => import('@/pages/insurer/fleet/policies.vue'),
    props: true,
    name: 'insurer.fleet.policies',
    meta: {
      breadCrumb: 'Fleet Policies',
      requiresAuth: true,
      title: 'Fleet Policies',
    },
  },
  {
    path: '/fleets/vehicle-upload',
    component: () => import('@/pages/insurer/fleet/vehicle-upload.vue'),
    name: 'insurer.fleet.vehicle-upload',
    meta: {
      breadCrumb: 'Vehicle Upload',
      requiresAuth: true,
      title: 'Bulk Upload Vehicles',
    },
  },
  {
    path: '/notifications',
    component: () => import('@/pages/insurer/Notifications.vue'),
    name: 'insurer.notifications',
    meta: {
      title: 'Notifications',
      requiresAuth: true,
    },
  },
  {
    path: '/reports',
    component: () => import('@/pages/insurer/reports/index.vue'),
    name: 'insurer.reports',
    meta: {
      breadCrumb: 'Reports',
      requiresAuth: true,
      title: 'Reports',
    },
  },
  {
    path: '/users',
    component: () => import('@/pages/insurer/users/AllUsers.vue'),
    name: 'insurer.users',
    meta: {
      breadCrumb: 'Users',
      requiresAuth: true,
      title: 'Users',
    },
  },
  {
    path: '/users/:id/edit',
    component: () => import('@/pages/insurer/users/EditUser.vue'),
    props: true,
    name: 'insurer.users.edit',
    meta: {
      breadCrumb: 'Edit User',
      requiresAuth: true,
      title: 'Edit User',
    },
  },
  {
    path: '/users/create',
    component: () => import('@/pages/insurer/users/CreateUser.vue'),
    props: true,
    name: 'insurer.users.create',
    meta: {
      breadCrumb: 'Create User',
      requiresAuth: true,
      title: 'Create User',
    },
  },
]
